/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

import Swiper from './../libs/swiper';

$(function () {
    function initBrandsEvents(){
        let $section = $('.section-about-brands');
        if(!$section.length){
            return;
        }

        let brandsSwiper = new Swiper('.section-about-brands .brands-container', {
            effect: 'coverflow',
            centeredSlides: true,
            loop: true,
            slidesPerView: 'auto',
            coverflowEffect: {
                rotate: 0,
                stretch: 30,
                depth: 30,
                modifier: 6,
                slideShadows : false,
            },
            on: {
                slideChangeTransitionEnd: function () {
                    $section.find('.brand-menu a[data-index="'+$(this.slides[this.realIndex]).data('index-parent')+'"]').click();
                },
            },
        });

        $section.find('.brand-menu a').click(function(){
            $section.find('.brand-menu a').removeClass('active');
            $(this).addClass('active');

            if($(brandsSwiper.slides[brandsSwiper.realIndex]).data('index-parent')!==$(this).data('index') && brandsSwiper.realIndex!==$(this).data('index')){
                brandsSwiper.slideToLoop($(this).data('index'));
            }
        });
    }

    initBrandsEvents();

    function initHowWorkEvents() {
        let $section = $('.section-about-how-work');
        if(!$section.length){
            return;
        }

        $section.find('.about-nav a').on('shown.bs.tab', function (e) {
            let value = $(e.target).attr('href').substr(5)

            $('body')
                .removeClassStartsWith('config-finance_type-')
                .addClass('config-finance_type-'+value);
        })
    }

    initHowWorkEvents();
});
